import { api } from '@/services';
import { USER_MANAGEMENT_API_ENDPOINTS } from '@/constants';
import { ApiResponse } from '@/types';

import {
  IUserDetails,
  IUserUpdate,
} from '@/features/user-management/user-management-update/interfaces';

export const UserUpdateService = {
  getUserDetails: async (id: string): Promise<IUserDetails> => {
    const response = await api.get(
      `${USER_MANAGEMENT_API_ENDPOINTS.USER_DETAILS.replace(':id', id)}`,
    );
    return response.data.data;
  },
  updateUser: async (id: string, payload: IUserUpdate): Promise<ApiResponse<boolean>> => {
    const response = await api.patch(
      `${USER_MANAGEMENT_API_ENDPOINTS.USER_UPDATE.replace(':id', id)}`,
      payload,
      {
        skipErrorAlert: true,
      },
    );
    return response.data;
  },
};
